// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".footer button[data-v-9a79ca48] {\n  width: 200px;\n}", ""]);
// Exports
module.exports = exports;
